import {
  ZIPCODE_ADDRESS_STORE,
  ZIPCODE_ADDRESS_STORE_ERROR,
  CLEAN_ZIPCODE_ADDRESS_STORE,
  CLEAN_ZIPCODE_ADDRESS_STORE_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function zipCodeAddressStoreReducer(state = initialState, action) {
  switch (action.type) {
    case ZIPCODE_ADDRESS_STORE:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case ZIPCODE_ADDRESS_STORE_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_ZIPCODE_ADDRESS_STORE:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_ZIPCODE_ADDRESS_STORE_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
